var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1118.32 628.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3aada6;}.cls-2{fill:#265b38;}.cls-3{fill:#3a4e65;}.cls-4{fill:#845088;}.cls-5{fill:#5b5150;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.58,338.21a8.77,8.77,0,0,0-8.83-8.7c-2.37-.06-4.75-.15-7.11,0-1.92.15-2.36-.57-2.26-2.36.14-2.58.08-5.18,0-7.77a17.82,17.82,0,0,0-15.78-17c-6.78-.72-13.61-.16-20.42-.28-2.42,0-4.83,0-7.54,0,1.55-2.79,3-5.28,4.31-7.8a3.43,3.43,0,0,1,2.26-1.83,13.63,13.63,0,1,0-13.28-22.83,13.43,13.43,0,0,0-3.1,14.71,3.37,3.37,0,0,1-.21,3.45c-2.47,4.2-4.84,8.47-7.15,12.76a2.51,2.51,0,0,1-2.57,1.55q-18.33-.08-36.66,0a2.52,2.52,0,0,1-2.62-1.46c-2.37-4.43-4.85-8.8-7.37-13.14a2.82,2.82,0,0,1-.15-2.87,13,13,0,0,0,.2-10.15,13.68,13.68,0,0,0-26.36,3.6,13.76,13.76,0,0,0,9.17,14.19c.89.33,2,.19,2.65,1.34,1.43,2.73,3,5.41,4.6,8.3a2.77,2.77,0,0,1-.48.11c-8.15,0-16.29,0-24.44.07-9.53.1-16.9,6-18.54,15-.63,3.43-.28,6.95-.23,10.42,0,1.5-.3,2.11-1.93,2-2.36-.15-4.74-.07-7.13,0-5.3.1-9.13,3.79-9.16,9.07q-.09,16,0,32a8.8,8.8,0,0,0,8.42,8.91,51,51,0,0,0,7.1.05c2.08-.15,2.87.35,2.72,2.61a45.8,45.8,0,0,0,.6,10.84,54.54,54.54,0,0,0,54,45.74q27.22.23,54.44,0c19-.19,34.12-8.16,45.1-23.64a52.54,52.54,0,0,0,9.64-31.94c0-3.57,0-3.57,3.65-3.57,2.15,0,4.3.06,6.44-.12a8.66,8.66,0,0,0,8.06-8.54Q610.71,354.56,610.58,338.21ZM472,365.9a16,16,0,1,1,15.84-16.06V350A16.08,16.08,0,0,1,472,365.9Zm56.3,41q-17.75,0-35.5,0c-5.55,0-9.56-4-9.5-9.24s4-8.91,9.53-8.95c5.92,0,11.83,0,17.75,0H528.3c5.48,0,9.45,3.81,9.49,9s-4,9.2-9.53,9.21Zm21-41A15.95,15.95,0,1,1,548.8,334h.52a15.95,15.95,0,0,1-.08,31.89Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2-3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.7,437.29c-.23-1.09-1.28-1-2-1.15A28.32,28.32,0,0,1,.14,409.23c-.68-16,1-31.64,8.38-46.14,6.11-11.92,15.72-18.83,29.4-19.53A12.37,12.37,0,0,1,45,345.28c5.3,3,10.14,6.84,16,9.06,13.14,5,25.44,3.21,37.22-4a32.51,32.51,0,0,0,3.85-2.5c7.68-6.34,15.84-4.9,24-1.34,11.53,5.05,17.23,15,20.83,26.32A100.25,100.25,0,0,1,151,411.68c-1,12.35-11.34,22.73-24.42,24.95-.64.11-1.47-.28-1.79.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,300.33c.44-24.76,20.1-43.77,44.72-43.32a43.7,43.7,0,0,1-1.3,87.39h-.57A43.42,43.42,0,0,1,31,300.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-4",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2-4",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M991.7,180.29c-.23-1.09-1.28-1-2-1.15a28.32,28.32,0,0,1-22.59-26.91c-.68-16,1-31.64,8.38-46.14,6.11-11.92,15.72-18.83,29.4-19.53a12.37,12.37,0,0,1,7.08,1.72c5.3,3,10.14,6.84,16,9.06,13.14,5,25.44,3.21,37.22-4a32.51,32.51,0,0,0,3.85-2.5c7.68-6.34,15.84-4.9,24-1.34,11.53,5,17.23,15,20.83,26.32a100.25,100.25,0,0,1,4.14,38.83c-1,12.35-11.34,22.73-24.42,24.95-.64.11-1.47-.28-1.79.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M998,43.33c.44-24.76,20.1-43.77,44.72-43.32a43.7,43.7,0,0,1-1.3,87.39h-.57A43.42,43.42,0,0,1,998,43.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-5",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2-5",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M991.7,404.29c-.23-1.09-1.28-1-2-1.15a28.32,28.32,0,0,1-22.59-26.91c-.68-16,1-31.64,8.38-46.14,6.11-11.92,15.72-18.83,29.4-19.53a12.37,12.37,0,0,1,7.08,1.72c5.3,3,10.14,6.84,16,9.06,13.14,5,25.44,3.21,37.22-4a32.51,32.51,0,0,0,3.85-2.5c7.68-6.34,15.84-4.9,24-1.34,11.53,5.05,17.23,15,20.83,26.32a100.25,100.25,0,0,1,4.14,38.83c-1,12.35-11.34,22.73-24.42,24.95-.64.11-1.47-.28-1.79.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M998,267.33c.44-24.76,20.1-43.77,44.72-43.32a43.7,43.7,0,0,1-1.3,87.39h-.57A43.42,43.42,0,0,1,998,267.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-6",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2-6",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M991.7,628.29c-.23-1.09-1.28-1-2-1.15a28.32,28.32,0,0,1-22.59-26.91c-.68-16,1-31.64,8.38-46.14,6.11-11.92,15.72-18.83,29.4-19.53a12.37,12.37,0,0,1,7.08,1.72c5.3,3,10.14,6.84,16,9.06,13.14,5,25.44,3.21,37.22-4a32.51,32.51,0,0,0,3.85-2.5c7.68-6.34,15.84-4.9,24-1.34,11.53,5.05,17.23,15,20.83,26.32a100.25,100.25,0,0,1,4.14,38.83c-1,12.35-11.34,22.73-24.42,25-.64.11-1.47-.28-1.79.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M998,491.33c.44-24.76,20.1-43.77,44.72-43.32a43.7,43.7,0,0,1-1.3,87.39h-.57A43.42,43.42,0,0,1,998,491.33Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 204.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 249.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 293.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 337.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 702.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 658.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 747.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 791.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 835.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 879.32,
    cy: 357.31,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 815.75,
    cy: 505.93,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 772.97,
    cy: 491.95,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 731.15,
    cy: 478.28,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 900.14,
    cy: 533.69,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 857.37,
    cy: 519.71,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 815.54,
    cy: 506.03,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 689.33,
    cy: 464.61,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 647.51,
    cy: 450.94,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 730.9,
    cy: 221.93,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 773.67,
    cy: 207.95,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 815.49,
    cy: 194.28,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 646.51,
    cy: 249.69,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 689.28,
    cy: 235.71,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 731.1,
    cy: 222.03,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 857.32,
    cy: 180.61,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 899.14,
    cy: 166.94,
    r: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b400f07d2a87c5a5f4a58a34998f5d9a.svg";
export { ForwardRef as ReactComponent };